import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getMeQueryOptions } from '../../auth/services/useMeQuery'
import { settingsApi } from '../api/settingsApi'

export const useClearMailDeliveryIssuesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: settingsApi.clearMailDeliveryIssues,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: getMeQueryOptions().queryKey }),
  })
}
